import React from 'react';
import { Grid } from '@material-ui/core';
import { Text } from 'library';
import LogoTextPair from './LogoTextPair';
import { NextStepType } from '../IndeedModels';
import DownloadIcon from 'assets/icons/indeed-home/download.svg';
import LoginIcon from 'assets/icons/indeed-home/log-in-sharp.svg';
import ManageIcon from 'assets/icons/indeed-home/manage-jobs.svg';

const IndeedNextSteps = () => {
    const nextSteps: NextStepType[] = [
        {
            icon: <DownloadIcon />,
            text: "We'll text you a link to download the app.",
        },
        {
            icon: <LoginIcon />,
            text: 'Log in using the credentials you add here.',
        },
        {
            icon: <ManageIcon />,
            text: 'The job will be waiting for you in the app!',
        },
    ];

    return (
        <Grid container direction="column" style={{ width: '100%', margin: 15 }} spacing={2}>
            <Grid item xs={12}>
                <Text variant="h2" bold>
                    Next Steps:
                </Text>
            </Grid>
            {nextSteps.map((nextStep) => {
                return <LogoTextPair icon={nextStep.icon} text={nextStep.text} key={nextStep.text} />;
            })}
        </Grid>
    );
};

export default IndeedNextSteps;
